module.exports = __webpack_public_path__ + "img/drawing_shanshui.8db92c8d.png";